import Styled from 'styled-components';
import { respondTo } from '@/respondTo';

export const SectionContainer = Styled.div`
display: flex;
flex-direction: column;
padding: 0.625rem 0 5rem;
max-width: 1512px;


${respondTo.tablet_landscape_s`
    padding: 0.625rem 0 2.5rem;
    `}

${respondTo.desktop_xl`
    padding: 4.375rem;
   
    `}
`

export const MainInnerContainer = Styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: 100%;

${respondTo.tablet_portrait`
    flex-direction: row;
    `}
${respondTo.tablet_landscape_s`
    flex-direction: row;
    padding: 2.5rem;
    justify-content: center;
    align-items: center;
    `} 

${respondTo.desktop`
justify-content: center;
    align-items: flex-start;
    gap: 2rem;
    `}

${respondTo.desktop_xl`
    padding: 2.5rem 0;
     justify-content: space-between;
    `}

`;
export const ImgContainer = Styled.div`
    display: flex;
    position: relative;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    overflow: hidden;

    ${respondTo.tablet_portrait`
   order: 1;
    `
    }
`;

export const ImgBoxSmall = Styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 0 0 1.25rem;
    img {
        height: auto;
        width:80%;
    }

    

    ${respondTo.tablet_portrait`
    padding: 0 0 2.5rem;
    img {
        height: auto;
        width:100%;
    }
    `}

    ${respondTo.tablet_landscape_s`
    display: none;
    `
    } 
`;

export const ImgBoxBig = Styled.div`
    display: none;
 

    ${respondTo.tablet_landscape_s`
    display: flex;
    justify-content: flex-end;
     img {
        width: 100%;
        height:  auto;
    }
    `
    }

    ${respondTo.desktop_xl`
    img {
        width: 100%;
        height: auto;
    }
    `
    }


`;


export const ContentBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2.5rem 1.25rem 1.25rem;
    gap: 2.5rem;

    ${respondTo.tablet_portrait`
        align-items: flex-start;
        `}

    ${respondTo.tablet_landscape_s`
    padding: 0;
    max-width: 406px;
    gap: 5.625rem;
    align-items: flex-start;
    align-self: center;
   
    `}

    ${respondTo.desktop`
    max-width: 500px;
    
    `
    }

    ${respondTo.desktop_xl`
    max-width: 580px;
    gap: 6.25rem;
    `}

`;


export const ButtonBox = Styled.div`
  
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.625rem;

    ${respondTo.tablet_portrait`
    flex-direction: row;
    `}

    ${respondTo.tablet_landscape_s`
    flex-direction: row;
    gap: 0.625rem;
    `}
    `;

export const DescriptionContainer   = Styled.div`

${respondTo.tablet_landscape_s`
    display: flex;
    `}
    `;

export const Descripton = Styled.p<{color?:string}>`
color: ${({color}) => color ? color : '#000000'};
display: inline-block;
text-align: center;

${respondTo.tablet_landscape_s`
    text-align: center;
    `}

`;

export const FootContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    padding: 0 1.25rem;

    ${respondTo.tablet_landscape_s`
    padding: 0 2.5rem;
    `}

    ${respondTo.desktop_xl`
    padding: 0;
    `}
    `;


export const Item = Styled.li`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    flex-direction: row;
    color: var(--on-surface-dark);
  `

export const UlContainer = Styled.ul`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 1.25rem;
    row-gap: 0.625rem;
    width: 100%;

    ${respondTo.tablet_landscape_s`
    grid-template-columns: repeat(3, 1fr);
    column-gap: 7.5rem;
    
    `}

    `;